/**
 * @description 탭 컴포넌트
 * @param {string} label - 탭 라벨
 * @param {boolean} isActive - 탭 활성 여부
 * @param {() => void} onClick - 탭 클릭 이벤트 핸들러
 */

interface TabItemProps {
  label: string;
  isActive: boolean;
  isView: boolean;
  onClick: () => void;
}

const TabItem = ({ label, isActive, isView, onClick }: TabItemProps): JSX.Element => {
  const className = `tab_txt ${isActive ? "on" : ""}`;

  return isView ? (
    <div className={className} onClick={onClick}>
      {label}
    </div>
  ) : (
    <></>
  );
};

export default TabItem;
